import { Typography, Box, Container } from '@mui/material';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

      <ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="container subPageContainer">
          <Typography variant='h1' className='sectionTitle'>Impressum</Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Angaben gemäß § 5 TMG</Typography>
          <Typography variant='body1' className='sectionText'>
            Notare Dr. Antonia Harbecke und Dr. Martin Konstantin Thelen<br />
            Holzgasse 29-33<br />
            53721 Siegburg
          </Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Aufsichtsbehörde</Typography>
          <Typography variant='body1' className='sectionText'>
            Präsident des Landgerichts Bonn<br />
            Wilhelmstraße 21, 53111 Bonn <br /><br />
            Präsident des Oberlandesgerichts Köln<br />
            Reichenspergerplatz 1, 50670 Köln
          </Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Berufsbezeichnung und besondere berufliche Regelungen</Typography>
          <Typography variant='body1' className='sectionText'>
            Berufsbezeichnung: Notar<br />
            Kammer: Rheinische Notarkammer<br /><br />

            Burgmauer 53, 50667 Köln<br />

            Verliehen in: Bundesrepublik Deutschland<br /><br />

            Der Berufsstand Notar / Notarin unterliegt den unter https://www.notar.de/der-notar/berufsrecht genannten berufsrechtlichen Regelungen.
          </Typography>


          <Typography variant='h2' className='sectionTitle3 marginTop'>Verantwortliche</Typography>
          <Typography variant='body1' className='sectionText'>
            Notare Dr. Antonia Harbecke und Dr. Martin Konstantin Thelen <br />
            Holzgasse 29-33 <br />
            53721 Siegburg
          </Typography>


        </Container>


<Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide">
                                        <Typography variant='h2' className='sectionTitle white'>
                                            Sie haben Fragen?  <br />
                                            Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                        </Typography>
                                        <Typography variant='body1' paragraph className='whiteText'>
                                        Harbecke & Thelen Notare<br />
                    Holzgasse 29 - 33<br />
                    Siegburg 53721<br />
                                        </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>

      </main >
      <Footer />
    </div >
  );
}

export default Imprint;